"use client";

import Script from "next/script";

import useInteractionDeferred from "@/hooks/useInteractionDeferred";
import { env } from "@/env.mjs";

// ----------------------------------------------------------------------------
// Apollo tracker is ~317KB of JS — the single largest third-party cost on the
// homepage. Defer it until first user interaction (or 5s fallback) so it
// doesn't compete with the LCP element for main-thread time.
// ----------------------------------------------------------------------------

const ApolloTrackerScript = () => {
  const ready = useInteractionDeferred();

  if (!env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES) return null;
  if (!ready) return null;

  return (
    <Script
      id="apollo-tracker"
      src={`https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${Math.random().toString(36).substring(7)}`}
      strategy="lazyOnload"
      onLoad={() => {
        if (typeof window !== "undefined" && window.trackingFunctions) {
          window.trackingFunctions.onLoad({
            appId: "67101e4fe771dc01b18dcdbd",
          });
        }
      }}
    />
  );
};

export default ApolloTrackerScript;
